var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.3333C12.5333 10.3333 11.6667 10.2 10.9333 9.93333H10.7333C10.5333 9.93333 10.4 10 10.2667 10.1333L8.8 11.6C6.93333 10.6 5.33333 9.06667 4.4 7.2L5.86667 5.73333C6.06667 5.53333 6.13333 5.26667 6 5.06667C5.8 4.33333 5.66667 3.46667 5.66667 2.66667C5.66667 2.33333 5.33333 2 5 2H2.66667C2.33333 2 2 2.33333 2 2.66667C2 8.93333 7.06667 14 13.3333 14C13.6667 14 14 13.6667 14 13.3333V11C14 10.6667 13.6667 10.3333 13.3333 10.3333ZM3.33333 3.33333H4.33333C4.4 3.93333 4.53333 4.53333 4.66667 5.06667L3.86667 5.86667C3.6 5.06667 3.4 4.2 3.33333 3.33333ZM12.6667 12.6667C11.8 12.6 10.9333 12.4 10.1333 12.1333L10.9333 11.3333C11.4667 11.4667 12.0667 11.6 12.6667 11.6V12.6667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialler);
export default __webpack_public_path__ + "static/media/Dialler.5e3cd61d585a9c24a31ebbb4a0530400.svg";
export { ForwardRef as ReactComponent };